<template>
  <div v-if="project">
    <v-offline
      online-class="online"
      offline-class="offline"
      @detected-condition="amIOnline"
    >
      <template v-slot:[onlineSlot] :slot-name="onlineSlot">
        {{ onlineOfflineMsg }}
      </template>
      <template v-slot:[offlineSlot] :slot-name="offlineSlot">
        {{ onlineOfflineMsg }}
      </template>
    </v-offline>
    <div class="row">
      <div class="col-lg-6">
        <div class="ibox">
          <div class="ibox-content">
            <div class="panel-heading">
              <h2 class="set_font_title">
                {{ metaData[project.type].title }}
                <a
                  class="btn-rotate help-icon"
                  style="cursor: pointer"
                  @click="showUrl()"
                >
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                </a>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 text-right up_kml_btn">
          <button v-if="!isReadOnly" v-bind:disabled="!onLine" @click="uploadVaccinationArea"
              class="btn btn-warning" type="button">
              UPLOAD GEOFENCE (KML)
          </button>
      </div>
    </div>
    <div v-if="!isReadOnly">
      <div class="card p-2">
        <MapBase
          :enableDraw="true"
          :enableKml="true"
          :enableSearch="true"
          :kmlFiles="kmlFiles"
          :center="mapCenter"
          :zoom="7"
          @shape-drawn="onDraw"
        />
      </div>
      <div>
        <div v-if="!isLocationConfirmed && selectedLocation">
          <p>Is selected Location confirmed?</p>
          <el-button
            @click="fetchLocality"
            :loading="loadingLocation"
            type="primary"
          >
            Yes
          </el-button>
          <el-button
            @click="
              enableMapSearch = true;
              selectedLocation = null;
            "
            type="info"
          >
            No
          </el-button>
        </div>
        <div></div>
        <form
          @submit.prevent="submit"
          class="form-horizontal"
          :hidden="!isLocationConfirmed"
        >
          <div class="row fence-fields" id="fence-fields-">
            <div class="col-sm-12 col-md-3">
              <label>Area Name <span class="error">*</span></label>
              <input class="form-control" v-model="areaName" required />
            </div>
            <div class="col-sm-12 col-md-3">
              <label>Country <span class="error">*</span></label>
              <input class="form-control" v-model="areaCountry" required />
            </div>
            <div class="col-sm-12 col-md-3">
              <label>State/Province<span class="error">*</span></label>
              <input class="form-control" v-model="stateProvince" required />
            </div>
            <div class="col-sm-12 col-md-3">
              <label>City/District/Village <span class="error">*</span></label>
              <input
                class="form-control"
                v-model="cityDistrictVillage"
                required
              />
            </div>
          </div>
          <div class="form-group text-right mt-3">
            <el-button @click="navigateToAreas" type="primary" plain>
              Cancel
            </el-button>
            <el-button native-type="submit" type="primary">
              Save
            </el-button>
          </div>
        </form>
      </div>
    </div>
    <help-modal ref="helpModal"></help-modal>
  </div>
</template>
<script>
import mixin from "../../mixins/GlobalMixin";
import { Button, Dialog } from "element-ui";
import VOffline from "v-offline";

import MapBase from "../map/MapBase.vue";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    VOffline,
    MapBase,
  },
  props: {
    projectId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isReadOnly: false,
      polygonstyles: [],
      project: null,
      cityDistrictVillage: "",
      stateProvince: "",
      areaCountry: "",
      kmlFiles: [],
      mapCenter: {},
      selectedLocation: null,
      isLocationConfirmed: false,
      loadingLocation: false,
      generatedKml: null,
      areaName: "",
      metaData: {
        "PM": {
          title: "Add Catch-Release Area",
          route: "pmAreas",
          kmlUploadRoute: "uploadAreaKmlPm"
        },
        "MV": {
          title: "Add Vaccination Area",
          route: "vaccinationAreas",
          kmlUploadRoute: "uploadAreaKml"
        }
      }
    };
  },
  mixins: [mixin],
  methods: {
    submit() {
      let vm = this;
      const loading = this.$loading({
        lock: true,
        text: 'Adding Area...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      axios
        .post("/area/create", {
          kml_data: vm.generatedKml,
          project_id: vm.projectId,
          name: vm.areaName,
          country: vm.areaCountry,
          google_admin_area_level1: vm.stateProvince,
          google_locality: vm.cityDistrictVillage,
        })
        .then((response) => {
          if (response.data.response.error.error_code == 0) {
            this.showAlert("Success", response.data.response.error.msg, true);
            this.navigateToAreas();
          } else {
            this.showAlert("Error", response.data.response.error.msg, false);
          }
        })
        .catch((error) => {
          this.showAlert(
            "Error",
            error.response.data.response.error.error_msg,
            false
          );
        })
        .finally(() => {
          loading.close();
        }); 
    },
    navigateToAreas() {
      this.$router.push({
        name: this.metaData[this.project.type].route,
        params: { projectId: this.projectId },
      });
    },
    logCode2(newShape) {
      let vm = this;
      let code = "";
      let kmltext1 =
        "<Placemark><name>" +
        "name of geofence" +
        "</name>\n" +
        "<description>" +
        "Description" +
        "</description>\n" +
        "<styleUrl>#" +
        "poly-01579B-6-0-nodesc" +
        "</styleUrl>\n" +
        "<Polygon>\n<tessellate>" +
        "1" +
        "</tessellate>\n" +
        "<outerBoundaryIs><LinearRing><coordinates>\n";

      code =
        newShape.map(([lng, lat]) => `${lng},${lat},0.0`).join(" \n") + " \n";

      let kmltext2 =
        "</coordinates></LinearRing></outerBoundaryIs>\n</Polygon>\n</Placemark>\n";

      let generatedKml =
        vm.kmlheading(newShape) + kmltext1 + code + kmltext2 + vm.kmlend();
      vm.generatedKml = generatedKml;
    },
    kmlheading(newShape) {
      let vm = this;
      let heading = "";
      let styleforpolygon = "";
      let i;
      heading =
        '<?xml version="1.0" encoding="UTF-8"?>\n' +
        '<kml xmlns="http://www.opengis.net/kml/2.2">\n' +
        "<Document><name>" +
        "Untitled layer" +
        "</name>\n" +
        "<description>" +
        "layer description" +
        "</description>\n";

      for (i = 0; i < newShape.length; i++) {
        styleforpolygon +=
          '<Style id="' +
          vm.polygonstyles[0].name +
          '">\n' +
          "<LineStyle><color>" +
          vm.polygonstyles[0].kmlcolor +
          "</color><width>" +
          vm.polygonstyles[0].width +
          "</width></LineStyle>\n" +
          "<PolyStyle><color>" +
          vm.polygonstyles[0].kmlfill +
          "</color></PolyStyle>\n" +
          "</Style>\n";
      }
      return heading + styleforpolygon;
    },
    kmlend() {
      let ending;
      return (ending = "</Document>\n</kml>");
    },
    createpolygonstyleobject() {
      let vm = this;
      let polygonstyle = {
        name: "Lump",
        kmlcolor: "CD0000FF",
        kmlfill: "9AFF0000",
        color: "#FF0000",
        fill: "#0000FF",
        width: 2,
        lineopac: 0.8,
        fillopac: 0.6,
      };
      vm.polygonstyles.push(polygonstyle);
    },
    uploadVaccinationArea() {
      this.$router.push({
        name: this.metaData[this.project.type].kmlUploadRoute,
        params: { projectId: this.projectId },
      });
    },
    showUrl() {
      this.$refs.helpModal.loadUrl(window.USER_MANUAL_URL + "#h.z5cvb0kvk9mx");
    },
    getAllKmls() {
      let vm = this;
      axios
        .get("/area/all/kmls/" + this.projectId)
        .then((response) => {
          let areaKmls = response.data.response.data.area_kmls;
          vm.kmlFiles = areaKmls.map((url) =>
            vm.addRegionToS3Host(url, "us-east-1")
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onDraw(shape) {
      this.logCode2(shape.geometry.coordinates[0]);
      if (shape.geometry.coordinates[0]) {
        const latLon = {
          x: shape.geometry.coordinates[0][0][0],
          y: shape.geometry.coordinates[0][0][1],
        };
        this.onAddressPicked(latLon);
      }
    },
    addRegionToS3Host(url, region = "ap-south-1") {
      return url.replace(".s3.amazonaws.com", `.s3.${region}.amazonaws.com`);
    },
    onAddressPicked(address) {
      this.selectedLocation = address;
      this.isLocationConfirmed = false;
    },
    async fetchLocality() {
      const vm = this;
      try {
        vm.loadingLocation = true;
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=geocodejson&lat=${this.selectedLocation.y}&lon=${this.selectedLocation.x}`,
          {
            headers: { "User-Agent": "App/1.0" }, // important for Nominatim
          }
        );
        const data = await res.json();

        const feature =
          data && data.features && data.features.length > 0
            ? data.features[0]
            : null;
        const props = feature && feature.properties ? feature.properties : {};
        const addr = props.geocoding ? props.geocoding : {};

        vm.areaCountry = addr.country || null;
        vm.stateProvince = addr.state || null;
        vm.cityDistrictVillage =
          addr.district ||
          addr.county ||
          addr.city ||
          addr.town ||
          addr.village ||
          null;

        vm.loadingLocation = false;
        vm.isLocationConfirmed = true;
      } catch (e) {
        console.error("Reverse geocode failed:", e);
        return null;
      }
    },
  },
  mounted() {
    let vm = this;
    vm.$store.dispatch("setScreenName", "Areas");
    vm.project = vm.$store.getters.getCurrentSelectedProject;
    let latLng = vm.project.project_location_lat_lng.split(",");
    vm.mapCenter = {
      lat: +latLng[0],
      lng: +latLng[1],
    };

    vm.isReadOnly = false;
    vm.$store.getters.getUserRoleForCurrentProject.forEach((r) => {
      if (r.role_name === "VIEWER") {
        vm.isReadOnly = true;
      }
    });
    vm.createpolygonstyleobject();

    vm.getAllKmls();
  },
};
</script>
<style scoped>
.help-icon {
  cursor: pointer;
  position: absolute;
  margin-left: 5px;
  margin-top: -15px;
  color: #51cbce !important;
}

.set_font_title {
  font-size: 20px;
  font-weight: 600;
  color: black;
  margin-left: -12px !important;
}
.fence-fields {
  padding-bottom: 0px !important;
  padding-top: 5px;
}
</style>
